export default "__VITE_ASSET__158ec341__"